<section class="tailored-cv-list" [nbSpinner]="loading" nbSpinnerStatus="primary">

  @if (!loading && items.length === 0) {
    <div class="tailored-empty">
      <span class="muted">{{ 'cv.tailored.empty' | translate }}</span>
    </div>
  } @else if (items.length > 0) {
    <table class="standard tailored-table">
      <thead>
        <tr>
          <th>{{ 'cv.tailored.date' | translate }}</th>
          @if (showUserColumn) {
            <th>{{ 'cv.tailored.user' | translate }}</th>
          }
          <th>{{ 'cv.tailored.vacancy' | translate }}</th>
          <th class="col-chip">{{ 'cv.tailored.cv' | translate }}</th>
          <th class="col-chip">{{ 'cv.tailored.letter' | translate }}</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        @for (item of items; track item.id) {
          <tr class="clickable" (click)="openRow(item)">
            <td class="col-date">
              <span [title]="item.created_at ?? ''">
                {{ item.created_at | date:'d MMM yyyy' }}
              </span>
            </td>
            @if (showUserColumn) {
              <td class="col-user">{{ item.subject_user_name }}</td>
            }
            <td class="col-vacancy">
              <span class="vacancy-title">{{ vacancyLabel(item) }}</span>
              @if (item.submitted_at) {
                <span class="submitted-badge-wrapper">
                  <nb-badge [text]="'cv.tailor.submit.badge' | translate" status="warning"></nb-badge>
                </span>
              }
              <!-- Only the outcomes someone has to act on. A linked package is
                   the expected case and would be noise on every row. -->
              @if (crmIssue(item)) {
                <span class="crm-chip" [title]="item.crm_sync_note ?? ''">
                  {{ ('cv.tailor.crm.' + item.crm_sync_state) | translate }}
                </span>
              }
            </td>
            <td class="col-chip">
              @if (item.cv_status !== 'none') {
                <nb-badge [text]="item.cv_status" [status]="chipStatus(item.cv_status)" position="top left"></nb-badge>
              }
            </td>
            <td class="col-chip">
              @if (item.letter_status !== 'none') {
                <nb-badge [text]="item.letter_status" [status]="chipStatus(item.letter_status)" position="top left"></nb-badge>
              }
            </td>
            <td class="col-actions">
              <div class="row-actions" (click)="$event.stopPropagation()">
                <button nbButton ghost status="primary" size="small"
                        [routerLink]="['/cv-generator/tailor', item.id]"
                        [attr.aria-label]="'cv.tailored.open' | translate"
                        [nbTooltip]="'cv.tailored.open' | translate">
                  <nb-icon icon="external-link-outline"></nb-icon>
                </button>
                @if (item.cv_pdf_available) {
                  <a [href]="downloadUrl(item.id)"
                     nbButton ghost status="primary" size="small"
                     target="_blank" rel="noopener"
                     [attr.aria-label]="('cv.tailored.download' | translate) + ' CV'"
                     [nbTooltip]="('cv.tailored.download' | translate) + ' CV'">
                    <nb-icon icon="download-outline"></nb-icon>
                  </a>
                }
                @if (item.letter_pdf_available) {
                  <a [href]="letterDownloadUrl(item.id)"
                     nbButton ghost status="basic" size="small"
                     target="_blank" rel="noopener"
                     [attr.aria-label]="('cv.tailored.download' | translate) + ' letter'"
                     [nbTooltip]="('cv.tailored.download' | translate) + ' letter'">
                    <nb-icon icon="file-text-outline"></nb-icon>
                  </a>
                }
                @if (item.submitted_at) {
                  <button nbButton ghost status="warning" size="small"
                          (click)="returnWork(item)"
                          [attr.aria-label]="'cv.tailor.submit.return' | translate"
                          [nbTooltip]="'cv.tailor.submit.return' | translate">
                    <nb-icon icon="undo-outline"></nb-icon>
                  </button>
                }
                @if (canDiscard(item)) {
                  <button nbButton ghost status="danger" size="small"
                          (click)="discard(item)"
                          [attr.aria-label]="'cv.tailored.discard' | translate"
                          [nbTooltip]="'cv.tailored.discard' | translate">
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

</section>
